import React from "react";
import PropTypes from "prop-types";
import "../../assets/stylesheets/ToolsGrid.css";

/* ---------------------------------------------
 * Pastel colors (ADDED — safe, local)
 * ------------------------------------------- */
const pastelColors = [
  "#eaf4ff53", // light blue
  "#eafbf353", // mint
  "#fff4e553", // peach
  "#f3edff53", // lavender
  "#f0fffa53", // soft pink
  "#fffef07b", // light cyan
];

/**
 * ToolsGrid
 *
 * Reusable grid of Home-Helper planning tools.
 * Width is controlled by the parent container.
 */
export default function ToolsGrid({
  category,
  zip,
  heading = "Helpful Planning Tools",
  subheading = "Explore free tools to plan, estimate, and prepare for your home improvement project.",
}) {
  const tools = [
    {
      slug: "cost-estimator",
      label: "Cost Estimator",
      description:
        "Estimate your project’s potential cost range based on scope, size, materials, and location.",
      icon: "/assets/icons/tools/cost-estimator.png",
    },
    {
      slug: "project-diagnostic",
      label: "Project Diagnostic",
      description:
        "Answer a few questions to understand whether repair, replacement, or monitoring makes the most sense.",
      icon: "/assets/icons/tools/project-diagnostic.png",
    },
    {
      slug: "measurement-calculator",
      label: "Measurement Calculator",
      description:
        "Quickly calculate rough measurements to help plan materials, layouts, and installation needs.",
      icon: "/assets/icons/tools/measurement-calculator.png",
    },
    {
      slug: "accessibility-planner",
      label: "Accessibility Planner",
      description:
        "Identify accessibility improvements that support safety, mobility, comfort, and aging in place.",
      icon: "/assets/icons/tools/accessibility-planner.png",
    },
    {
      slug: "inspiration-explorer",
      label: "Inspiration Explorer",
      description:
        "Explore styles, budgets, and project ideas to align expectations before starting a renovation.",
      icon: "/assets/icons/tools/inspiration-explorer.png",
    },
    {
      slug: "project-readiness",
      label: "Project Readiness",
      description:
        "Check if you’re prepared to start by reviewing planning, budgeting, timelines, and next steps.",
      icon: "/assets/icons/tools/project-readiness.png",
    },
  ];

  const buildHref = (slug) => {
    const params = new URLSearchParams();
    if (category) params.set("category", category);
    if (zip) params.set("zip", zip);
    const query = params.toString();
    return `/tools/${slug}${query ? `?${query}` : ""}`;
  };

  return (
    <section className="toolsGrid" style={{ textAlign: "center" }}>
      <h2 style={{ marginBottom: 8, textAlign: "center" }}>{heading}</h2>

      {subheading && (
        <p style={{ width: "80%", margin: "0 auto 2px", textAlign: "center" }}>
          {subheading}
        </p>
      )}

      <div className="toolgrid-template">
        {tools.map((tool, index) => (
          <a
            key={tool.slug}
            href={buildHref(tool.slug)}
            className="toolsGrid-bubble"
            style={{
              backgroundColor: pastelColors[index % pastelColors.length], 
            }}
          >
            <img
              src={tool.icon}
              alt={tool.label}
              className="toolsGridIcon"
            />

            <h3
              style={{
                margin: 0,
                fontSize: "1.1rem",
                fontWeight: 600,
                color: "#1385ff",
                textAlign: "center",
              }}
            >
              {tool.label}
            </h3>

            <p
              style={{
                marginTop: 8,
                lineHeight: 1.4,
                textAlign: "center",
                color: "#555",
              }}
            >
              {tool.description}
            </p>
          </a>
        ))}
      </div>
    </section>
  );
}

ToolsGrid.propTypes = {
  category: PropTypes.string,
  zip: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
};
